import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {Document, EntityType, GeneralFilter, ConfirmationModalComponent, ConfirmationModalConfig, ServiceOrder, ToastConfig} from '@app/shared';
import {ProjectUtilsService} from '../../../services/project-utils.service';
import {combineLatest, interval, Subject, take, takeUntil} from 'rxjs';
import {DocDrawerComponent} from '../../../../../shared/components/doc-drawer/doc-drawer.component';
import {DocModalComponent} from '../../../../../shared/components/doc-modal/doc-modal.component';
import {DocumentService, ScreenService, StServiceService} from '@app/core';
import {NzDrawerService} from 'ng-zorro-antd/drawer';
import {NzModalService} from 'ng-zorro-antd/modal';
import {NzNotificationRef, NzNotificationService} from 'ng-zorro-antd/notification';
import {GlobalValuesService} from '../../../../../core/services/global-values.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../../../../core/services/auth.service';

@Component({
  selector: 'app-doc-section',
  standalone: false,

  templateUrl: './doc-section.component.html',
  styleUrl: './doc-section.component.less'
})
export class DocSectionComponent implements OnDestroy, OnInit {

  @Input() entityId: number = 0;
  @Input() entityType: EntityType = 'Project';
  @Input() serviceOrder: ServiceOrder | undefined;
  @Output() isDocDrawerOpen: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() mblUpdatedEvent = new EventEmitter<string>();

  // @ViewChild('confirmationModal') confirmationModal!: ConfirmationModalComponent;
  docCardsActivate: number[] = [];
  documentsFilters: GeneralFilter[] = [
    {
      name: 'Tipo de documento',
      icon: 'arrow_drop_down',
      active: false,
    },
    {
      name: 'Pendientes de validación',
      icon: '',
      active: false,
    },
    {
      name: 'Rechazados',
      icon: '',
      active: false,
    },
  ];
  documentTypeFiltervalue: string = '';
  pendingStateFilterValue: boolean = false;
  rejectStateFilterValue: boolean = false;
  documentTypes: { name: string, id: number }[] = [];
  documentTypesAvailable:{ name: string, id: number }[] = [];
  filteredDocuments: Document[] = [];
  docDrawer: any;
  uploadDocsModalRef: any;
  deleteDocsModalRef: any;
  uploadDocsDrawerRef: any;
  showDocsFilters = false;
  isMobile$;
  private destroy$ = new Subject<void>();

  private readonly documentsPageSize = 1000;
  private aiPollingDestroy$ = new Subject<void>();
  private isAiPolling = false;
  /** Pasado este tiempo desde la subida se deja de esperar al análisis con IA. */
  private readonly aiAnalysisTimeoutMs = 10 * 60 * 1000;
  /** Documento que pidieron abrir por query params y aun no se ha podido resolver. */
  private pendingDocIdToOpen: number | undefined;
  @ViewChild('notificationTmpl') notificationTmpl: any;
  notRef: NzNotificationRef | undefined;
  toastConfig: ToastConfig = {
    icon: 'check_circle',
    iconColor: '#6CDA75',
    content: '',
    showUndo: false
  };

  constructor(private ps: ProjectUtilsService, private screenService: ScreenService,
              private drawerService: NzDrawerService, private modalService: NzModalService,
              public globalValuesService: GlobalValuesService,
              private route: ActivatedRoute,
              private router: Router,
              private cdr: ChangeDetectorRef,
              public authService: AuthService,
              private documentService: DocumentService,
              private stServiceService: StServiceService,
              private notificationService: NzNotificationService
  ) {

    this.isMobile$ = screenService.isMobile$;
    globalValuesService.documentTypes$.pipe(takeUntilDestroyed())
      .subscribe(value => this.documentTypes = value)

    this.ps.closeAllDrawers$.pipe(takeUntilDestroyed()).subscribe(value => {
      if (value) {
        this.docDrawer?.close();
        this.uploadDocsModalRef?.close();
        this.deleteDocsModalRef?.close();
        this.uploadDocsDrawerRef?.close();
      }
    })
  }

  _documents: Document[] = [];

  get documents() {
    return this._documents;
  }

  @Input()
  set documents(value: Document[]) {
    this._documents = value;
    this.updateFiltersVisibility();
    this.filterDocuments();
  }

  // Saber si todos estan seleccionados
  get isAllSelected(): boolean {
    return this.documents!.every(item => this.docCardsActivate.includes(item.id));
  }

  // Saber si solo algunos estan seleccionados
  get isIndeterminate(): boolean {
    const hasSelected = this.documents!.some(item =>
      this.docCardsActivate.includes(item.id)
    );
    return !this.isAllSelected && hasSelected;
  }

  // TODO: Hacer un setter para documents y llamar a this.filterDocuments();

  ngOnInit(): void {
    this.refreshDocumentsFromServer();

    this.route.queryParams.pipe(
      takeUntil(this.destroy$)
    ).subscribe(params => {
      if (params['openDocuments'] === 'true') {
        // Se anota y se intenta: al llegar aqui desde una notificacion, la lista de documentos
        // todavia esta viajando, asi que resolverlo solo en este momento fallaba casi siempre.
        // El segundo intento lo hace refreshDocumentsFromServer cuando los documentos llegan.
        this.pendingDocIdToOpen = Number(params['docId']);
        this.openPendingDocument();
      }
    });
  }

  /**
   * Abre el documento pedido por query params, si ya esta cargado.
   *
   * @param documentsLoaded true cuando la lista acaba de llegar del servidor: solo entonces tiene
   * sentido dar por perdido el documento y limpiar la peticion.
   */
  private openPendingDocument(documentsLoaded: boolean = false): void {
    if (!this.pendingDocIdToOpen) return;

    const doc = (this.documents || []).find(d => d.id === this.pendingDocIdToOpen);

    if (doc) {
      this.openDocDrawer(doc);
    } else if (documentsLoaded) {
      console.error('Documento no encontrado con ID:', this.pendingDocIdToOpen);
    } else {
      // Aun no han llegado los documentos: se espera al refresco en vez de darlo por perdido.
      return;
    }

    this.pendingDocIdToOpen = undefined;

    // Remover parámetros después de usarlos
    this.router.navigate([], {
      queryParams: {
        openDocuments: null,
        docId: null  // También limpiamos docId
      },
      queryParamsHandling: 'merge'
    }).then();
  }

  ngOnDestroy() {
    this.stopAiPolling();
    this.docDrawer?.close();
    this.uploadDocsModalRef?.close();
    this.deleteDocsModalRef?.close();
    this.uploadDocsDrawerRef?.close();

    this.destroy$.next();
    this.destroy$.complete();
  }

  onFilterSelect(filterName: string, value?: string) {
    this.documentsFilters.forEach(f => f.name === filterName ? f.active = true : null);

    if (filterName === 'Pendientes de validación') {
      this.pendingStateFilterValue = !this.pendingStateFilterValue;
      if (!this.pendingStateFilterValue) {
        this.documentsFilters.find(d => d.name === filterName)!.active = false;
      }
    }

    if (filterName === 'Rechazados') {
      this.rejectStateFilterValue = !this.rejectStateFilterValue;
      if (!this.rejectStateFilterValue) {
        this.documentsFilters.find(d => d.name === filterName)!.active = false;
      }
    }

    if (filterName === 'Tipo de documento') {
      if (this.documentTypeFiltervalue === value!) {
        this.documentTypeFiltervalue = '';
        this.documentsFilters.find(d => d.name === filterName)!.active = false;
      } else {
        this.documentTypeFiltervalue = value!;
      }
    }

    this.filterDocuments();
  }

  onActionBtn(value: string, doc: Document): void {
    switch (value) {
      case 'drawer': {
        this.openDocDrawer(doc);
        break;
      }
      case 'options': {
        break;
      }
      case 'checkbox': {
        this.toggleDocCardsActivate(doc.id)
        break;
      }
      case 'delete': {
        this.openDeleteModalForSingleDoc(doc);
        break;
      }
    }
  }

  openDocDrawer(doc: Document): void {
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    }).pipe(take(1)).subscribe(({isMobile, isMedium}) => {
      this.docDrawer = this.drawerService.create({
        nzWidth: 635,
        nzHeight: '98%',
        nzPlacement: isMobile ? 'bottom' : 'right',
        nzClosable: false,
        nzMask: false,
        nzContent: DocDrawerComponent,
        nzData: {
          document: doc,
        }
      });

      // Espera a que el drawer esté completamente abierto
      this.docDrawer.afterOpen.pipe(take(1)).subscribe(() => {
        this.docDrawer.getContentComponent().deleteEvent.pipe(take(1)).subscribe((docs: Document[]) => {
          this.documents = this.documents!.filter(d => !docs.includes(d));
        });
      });

      this.isDocDrawerOpen.emit(true);

      this.docDrawer.afterClose.pipe(take(1)).subscribe(() => {
        this.isDocDrawerOpen.emit(false)
      });
    });
  }

  openUploadDocsModal(entityId: number, entityType: EntityType): void {
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    }).pipe(take(1)).subscribe(({isMobile, isMedium}) => {
      if (isMobile) {
        this.uploadDocsDrawerRef = this.drawerService.create({
          nzClosable: false,
          nzMask: false,
          nzHeight: '98%',
          nzPlacement: 'bottom',
          nzContent: DocModalComponent,
          nzData: {
            docModalType: 'upload',
            entityId: entityId,
            entityType: entityType,
          }
        });

        this.uploadDocsDrawerRef.afterOpen.pipe(take(1)).subscribe(() => {
          this.uploadDocsDrawerRef.getContentComponent().createEvent.pipe(take(1)).subscribe((docs: Document[]) => {
            this.documents = [...(this.documents || []), ...docs];
            this.cdr.detectChanges();
          });
        });

      } else {
        this.uploadDocsModalRef = this.modalService.create({
          nzFooter: null,
          nzContent: DocModalComponent,
          nzClosable: false,
          nzAutofocus: null,
          nzCentered: true,
          nzClassName: 'mobile-drawerlike',
          nzWidth: 'auto'
        });

        this.uploadDocsModalRef.afterOpen.pipe(take(1)).subscribe(() => {
          this.uploadDocsModalRef.getContentComponent().createEvent.pipe(take(1)).subscribe((docs: Document[]) => {
            this.documents = [...(this.documents || []), ...docs];
            this.cdr.detectChanges();
          });
        });

        this.uploadDocsModalRef.getContentComponent().docModalType = 'upload';
        this.uploadDocsModalRef.getContentComponent().entityId = entityId;
        this.uploadDocsModalRef.getContentComponent().entityType = entityType;
      }
    });
  }

  // openDeleteConfirmation(): void {
  //   const config: ConfirmationModalConfig = {
  //     title: 'Eliminar documentos',
  //     message: '¿Estás seguro que deseas eliminar estos documentos?',
  //     confirmText: 'Eliminar',
  //     cancelText: 'Cancelar',
  //     confirmButtonType: 'primary',
  //     confirmButtonDanger: true
  //   };
  //   this.confirmationModal.config = config;
  //   this.confirmationModal.open();
  // }
  //
  // onDeleteConfirmed(): void {
  // }

  openDeleteModal(): void {
    this.deleteDocsModalRef = this.modalService.create({
      nzFooter: null,
      nzContent: DocModalComponent,
      nzClosable: false,
      nzAutofocus: null,
      nzCentered: true,
      nzClassName: 'mobile-drawerlike',
      nzWidth: 'auto'
    });

    this.deleteDocsModalRef.getContentComponent().docModalType = 'delete';
    this.deleteDocsModalRef.getContentComponent().documentsToDelete =
      this.documents!.filter(d => this.docCardsActivate.includes(d.id));

    this.deleteDocsModalRef.afterOpen.pipe(take(1)).subscribe(() => {
      this.deleteDocsModalRef.getContentComponent().deleteEvent.pipe(take(1)).subscribe((docs: Document[]) => {
        this.documents = this.documents!.filter(d => !docs.includes(d));
        this.docCardsActivate = [];
      });
    });
  }

  openDeleteModalForSingleDoc(doc: Document): void {
    this.deleteDocsModalRef = this.modalService.create({
      nzFooter: null,
      nzContent: DocModalComponent,
      nzClosable: false,
      nzAutofocus: null,
      nzCentered: true,
      nzClassName: 'mobile-drawerlike',
      nzWidth: 'auto'
    });

    this.deleteDocsModalRef.getContentComponent().docModalType = 'delete';
    this.deleteDocsModalRef.getContentComponent().documentsToDelete = [doc];

    this.deleteDocsModalRef.afterOpen.pipe(take(1)).subscribe(() => {
      this.deleteDocsModalRef.getContentComponent().deleteEvent.pipe(take(1)).subscribe((docs: Document[]) => {
        this.documents = this.documents!.filter(d => !docs.includes(d));
        this.docCardsActivate = [];
      });
    });
  }

  toggleShowDocsFilters(): void {
    this.showDocsFilters = !this.showDocsFilters;
  }

  /** Logica de seleccionar documentos **/
  onDocCardClick(doc: any): void {
    this.docDrawer?.close();
    this.onActionBtn('drawer', doc);
  }

  toggleDocCardsActivate(value: number): void {
    if (this.docCardsActivate.includes(value)) {
      this.docCardsActivate = this.docCardsActivate.filter(v => v !== value);
    } else {
      this.docCardsActivate.push(value);
    }
  }

  toggleSelectAllDocs(): void {
    let newSet: number[] = [];
    if (!this.isAllSelected) {
      this.documents?.forEach(item => newSet.push(item.id));
    }
    this.docCardsActivate = newSet;
  }

  /** Lógica de subir y analizar con IA **/
  openUploadAndAnalyzeModal(): void {
    // Verificar que no hay otro documento en procesamiento
    if (this.documents?.some(d => this.isAiAnalysisPending(d))) {
      this.notificationService.warning(
        'Análisis en curso',
        'Ya hay un documento siendo analizado por IA. Espera a que finalice antes de subir otro.',
        {nzPlacement: 'bottomRight'}
      );
      return;
    }

    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    }).pipe(take(1)).subscribe(({isMobile, isMedium}) => {
      if (isMobile) {
        this.uploadDocsDrawerRef = this.drawerService.create({
          nzClosable: false,
          nzMask: false,
          nzHeight: '98%',
          nzPlacement: 'bottom',
          nzContent: DocModalComponent,
          nzData: {
            docModalType: 'upload',
            entityId: this.entityId,
            entityType: this.entityType,
            aiUploadMode: true,
          }
        });

        this.uploadDocsDrawerRef.afterOpen.pipe(take(1)).subscribe(() => {
          this.uploadDocsDrawerRef.getContentComponent().createEvent.pipe(take(1)).subscribe((docs: Document[]) => {
            this.documents = [...(this.documents || []), ...docs];
            if (docs.some(d => d.aiProcessingStatus === 'Processing')) {
              this.startAiPolling();
            }
            this.cdr.detectChanges();
          });
        });

      } else {
        this.uploadDocsModalRef = this.modalService.create({
          nzFooter: null,
          nzContent: DocModalComponent,
          nzClosable: false,
          nzAutofocus: null,
          nzCentered: true,
          nzClassName: 'mobile-drawerlike',
          nzWidth: 'auto'
        });

        this.uploadDocsModalRef.afterOpen.pipe(take(1)).subscribe(() => {
          this.uploadDocsModalRef.getContentComponent().createEvent.pipe(take(1)).subscribe((docs: Document[]) => {
            this.documents = [...(this.documents || []), ...docs];
            if (docs.some(d => d.aiProcessingStatus === 'Processing')) {
              this.startAiPolling();
            }
            this.cdr.detectChanges();
          });
        });

        this.uploadDocsModalRef.getContentComponent().docModalType = 'upload';
        this.uploadDocsModalRef.getContentComponent().aiUploadMode = true;
        this.uploadDocsModalRef.getContentComponent().entityId = this.entityId;
        this.uploadDocsModalRef.getContentComponent().entityType = this.entityType;
      }
    });
  }

  startAiPolling(): void {
    if (this.isAiPolling) return;
    this.isAiPolling = true;

    interval(10000).pipe(
      takeUntil(this.aiPollingDestroy$),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.refreshDocumentsFromServer(true);
    });
  }
  stopAiPolling(): void {
    this.aiPollingDestroy$.next();
    this.aiPollingDestroy$ = new Subject<void>();
    this.isAiPolling = false;
  }

  /** Sigue en análisis pasado el tiempo de espera: ya no se sondea ni bloquea otra subida con IA. */
  isAiStalled(document: Document): boolean {
    if (document.aiProcessingStatus !== 'Processing' || !document.createdOn) {
      return false;
    }
    return Date.now() - new Date(document.createdOn).getTime() > this.aiAnalysisTimeoutMs;
  }

  private isAiAnalysisPending(document: Document): boolean {
    return document.aiProcessingStatus === 'Processing' && !this.isAiStalled(document);
  }

  private refreshDocumentsFromServer(showAiFeedback: boolean = false): void {
    if (!this.entityId || !this.entityType) {
      return;
    }

    this.documentService.getDocument(this.getDocumentGetParams()).pipe(
      take(1),
      takeUntil(this.aiPollingDestroy$),
      takeUntil(this.destroy$)
    ).subscribe({
      next: (response: any) => {
        const updatedRows = response.data?.rows || [];
        const previousDocuments = this.documents || [];
        const previousDocumentsById = new Map(previousDocuments.map(document => [document.id, document]));
        const changedAiDocuments = updatedRows.filter((updatedDoc: Document) => {
          const previousDoc = previousDocumentsById.get(updatedDoc.id);
          return previousDoc?.aiProcessingStatus === 'Processing' &&
            (updatedDoc.aiProcessingStatus === 'Completed' || updatedDoc.aiProcessingStatus === 'Failed');
        });

        this.documents = updatedRows;
        this.docCardsActivate = this.docCardsActivate.filter(id => updatedRows.some((document: Document) => document.id === id));

        if (showAiFeedback) {
          changedAiDocuments.forEach((updatedDoc: Document) => this.showAiFeedback(updatedDoc));
        }

        if (changedAiDocuments.some((updatedDoc: Document) => updatedDoc.aiProcessingStatus === 'Completed') && this.serviceOrder) {
          this.refreshServiceOrder();
        }

        if (updatedRows.some((updatedDoc: Document) => this.isAiAnalysisPending(updatedDoc))) {
          this.startAiPolling();
        } else {
          this.stopAiPolling();
        }

        // Con los documentos ya en mano se atiende la peticion que llego por query params.
        this.openPendingDocument(true);

        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error consultando documentos:', error);
      }
    });
  }

  private getDocumentGetParams(): any {
    return {
      startRow: 0,
      endRow: this.documentsPageSize,
      sortDirection: 'asc',
      sortProperty: 'id',
      entityId: this.entityId,
      entityType: this.entityType,
    };
  }

  private refreshServiceOrder(): void {
    const params = {
      startRow: 0,
      endRow: 1,
      sortProperty: 'id',
      sortDirection: 'asc' as const,
      filterProperty: 'id',
      filterValue: this.serviceOrder!.id.toString(),
    };
    this.stServiceService.getServiceOrder(params)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          const updatedSo = response?.data?.rows?.[0];
          if (updatedSo?.mbl) {
            this.serviceOrder!.mbl = updatedSo.mbl;
            this.mblUpdatedEvent.emit(updatedSo.mbl);
          }
          this.cdr.detectChanges();
        },
        error: () => {
          console.error('El analisis IA completo pero no se pudo refrescar la Service Order.');
        }
      });
  }

  private showAiFeedback(document: Document): void {
    const rationale = document.aiExtractionRationale?.trim() || 'No se recibio detalle del analisis.';

    if (document.aiProcessingStatus === 'Completed') {
      this.toastConfig = {
        icon: 'check_circle',
        iconColor: '#6CDA75',
        content: 'Analisis IA completado',
        msg: rationale,
        showUndo: false
      };
      this.showNotification();
      return;
    }

    if (document.aiProcessingStatus === 'Failed') {
      this.toastConfig = {
        icon: 'dangerous',
        iconColor: '#CB2A2F',
        content: 'Error en analisis IA',
        msg: rationale,
        showUndo: false
      };
      this.showNotification();
    }
  }

  private showNotification(): void {
    this.notRef = this.notificationService
      .create('blank', '', this.notificationTmpl, {nzPlacement: 'bottomRight', nzDuration: 0});
  }
  private updateFiltersVisibility(): void {
    // Para el filtro "Pendientes de validación"
    const hasPending = this.documents?.some(doc => doc.validationStatus === 'ValidationPending');
    const pendingFilter = this.documentsFilters.find(f => f.name === 'Pendientes de validación');
    if (pendingFilter) {
      pendingFilter.hidden = !hasPending;
    }

    // Para el filtro "Rechazados"
    const hasRejected = this.documents?.some(doc => doc.validationStatus === 'NonValidated');
    const rejectedFilter = this.documentsFilters.find(f => f.name === 'Rechazados');
    if (rejectedFilter) {
      rejectedFilter.hidden = !hasRejected;
    }
  }


  filterDocuments(): void {
    let tempFiltered = this.documents || [];
    this.documentTypesAvailable = tempFiltered.reduce((acc: { name: string, id: number }[], document) => {
      // Procesar documentType si existe
      if (document.documentType && !acc.some(dt => dt.id === document.documentType!.id)) {
        acc.push(document.documentType);
      }

      // Procesar type si existe (convertir string a objeto con estructura compatible)
      if (document.type) {
        const typeAsObject = {
          id: -1, // Usar un ID negativo para diferenciar de los documentType reales
          name: document.type
        };

        // Verificar si ya existe en el acumulador por nombre (ya que el ID será siempre -1)
        if (!acc.some(dt => dt.name === document.type)) {
          acc.push(typeAsObject);
        }
      }
      return acc;
    }, []);
    if (this.documentTypeFiltervalue) {
      tempFiltered = tempFiltered.filter(d => d.type === this.documentTypeFiltervalue);
    }

    if (this.pendingStateFilterValue) {
      tempFiltered = tempFiltered.filter(d => d.validationStatus === 'ValidationPending');
    }

    if (this.rejectStateFilterValue) {
      tempFiltered = tempFiltered.filter(d => d.validationStatus === 'NonValidated');
    }

    this.filteredDocuments = tempFiltered;
  }

}

